import React, { createContext, useContext, useState, useEffect } from 'react';
import landingPageService from '../services/landingPageService';

const LandingPageContext = createContext();

export const LandingPageProvider = ({ children }) => {
  const [content, setContent] = useState({
    hero_section: null,
    about_section: null,
    solutions: [],
    team_members: [],
    team_content: null,
    funding_section: null,
    funding_options: [],
    smart_classroom_features: [],
    smart_classroom_content: null,
    tv_content: [],
    tv_section: null
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Load all content on mount
  useEffect(() => {
    loadContent();
  }, []);

  const loadContent = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await landingPageService.getAllContent();
      
      if (response.success) {
        setContent(response.data);
      } else {
        setError('Failed to load content');
      }
    } catch (err) {
      setError(err.message || 'Failed to load content');
      console.error('Error loading landing page content:', err);
    } finally {
      setLoading(false);
    }
  };

  // Subscribe to newsletter
  const subscribeNewsletter = async (email) => {
    try {
      const response = await landingPageService.subscribeNewsletter(email);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // Submit contact form
  const submitContactForm = async (formData) => {
    try {
      const response = await landingPageService.submitContact(formData);
      return response;
    } catch (error) {
      throw error;
    }
  };

  const value = {
    content,
    loading,
    error,
    loadContent,
    subscribeNewsletter,
    submitContactForm
  };

  return (
    <LandingPageContext.Provider value={value}>
      {children}
    </LandingPageContext.Provider>
  );
};

export const useLandingPage = () => {
  const context = useContext(LandingPageContext);
  if (!context) {
    throw new Error('useLandingPage must be used within a LandingPageProvider');
  }
  return context;
};

export default LandingPageContext;